module.exports = __webpack_public_path__ + "static/media/ic_send.cfb5ad09.png";